/* eslint-disable */
/* Page for testing markdown */

import React, { useMemo } from 'react';
import styled from 'styled-components/macro';
import { Layout } from 'components/organisms';
import {
  Title, Text, Spacer, Form
} from 'components/atoms';
import { MediaUploadGallery } from 'containers'
import PropTypes from 'prop-types'
import { useToggle } from 'hooks';
import RichTextEditorMarkdown from 'containers/RichTextEditorMarkdown/RichTextEditorMarkdown'
import { useLocalStorage } from 'react-use';
import { MarkdownRenderer as MarkdownRendererLib } from "../../assets/lib/components/molecules";
import { withPortalThemeLegacy } from 'modules/utils';

const MarkdownRenderer = props => withPortalThemeLegacy(MarkdownRendererLib, props)

const Dummy = () => {
  const [markdown, setMarkdown] = useLocalStorage('markdown-editor', '');

  const handleChangeMarkdown = (newMarkdown) => {
    setMarkdown(newMarkdown)
  }

  return (
    <Layout>
      <Page>
        <Spacer bottom="xl4">
          <Page.Header>
            <Title>Markdown</Title>
            <Text>
              Página para facilitar edição de markdown.
            </Text>
          </Page.Header>
        </Spacer>
        <Split>
          <RichTextEditorMarkdown
            initialMarkdown={markdown}
            onEditorStateChange={handleChangeMarkdown}
            isRaw
          />
          <div>
            <Spacer bottom="xs">
              <Text modifiers={['l']}>Preview:</Text>
            </Spacer>
            <Preview>
              <MarkdownRenderer content={markdown} activeColor="#95CA3D" />
            </Preview>
          </div>
        </Split>
      </Page>
    </Layout>
  );
};

const Page = styled.div`
`;

Page.Header = styled.div`
  margin-bottom: ${props => props.theme.spacing.l};
`;

const Split = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
`

const Preview = styled.div`
  padding: ${props => props.theme.spacing.xs};
  border: 1px solid ${props => props.theme.colors.border};
`

export default Dummy;
